import { RootState } from './../state/root.state';
import { ActionReducerMap } from '@ngrx/store';
import { routerReducer } from '@ngrx/router-store';

export const rootReducer: ActionReducerMap<RootState> = {
    router: routerReducer
}


